import React from 'react';
import { Header, Footer } from '../Common';
import CollectionShop from '../../Common/CollectionShop/CollectionShop';

/** CLS-FI public collection-shop listing (/clothing/cls-fi/collection/:collectionSlug). */
const CLSFICollectionShop = () => (
  <CollectionShop
    brandSlug="clsfi"
    feSlug="cls-fi"
    dataBrand="CLS"
    HeaderComponent={Header}
    FooterComponent={Footer}
    packageDescription="Pakettiratkaisu"
    loadingText="Ladataan tuotteita…"
    emptyTitle="Ei tuotteita juuri nyt"
    emptyText="Valikoimaa saatetaan juuri päivittää. Jos sinulla on kysyttävää, autamme mielellämme."
    contactLabel="Ota yhteyttä"
    faqLabel="FAQ"
  />
);

export default CLSFICollectionShop;
